import { HttpResponse } from 'msw'
import {
  SendVideoCallStartedNotificationDocument,
  SendVideoCallStartedNotificationMutation,
} from 'src/lib/gql-client'
import { graphQLHandlerFactory } from 'src/tests/mocks/handlerFactory'
import { generateUUID } from 'src/utils/generateUUID'

import { SendVideoCallStartedNotificationMutationVariables } from './../../../../lib/gql-client/client-preset/graphql'

export const sendVideoCallStartedNotificationHandler = graphQLHandlerFactory<
  SendVideoCallStartedNotificationMutation,
  SendVideoCallStartedNotificationMutationVariables
>('mutation', SendVideoCallStartedNotificationDocument, () => {
  return HttpResponse.json({
    data: {
      sendVideoCallStartedNotification: {
        trialPatientUid: generateUUID(),
      },
    },
  })
})
